import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=13ec30a4"
import script from "./Notification.vue?vue&type=script&setup=true&lang=ts"
export * from "./Notification.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports